<template>
  <div class="Enroll">
    <div class="panel" v-if="!inTime">
      <no_access></no_access>
    </div>
    <template v-else>
      <div class="panel" v-if="user.enrolled" >
        <enrolled></enrolled>
      </div>
      <div class="panel" v-else>
        <simple_enroll></simple_enroll>
      </div>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import FPHeader from '@/components/frontpage/Header.vue'
import Enrolled from '@/components/enroll/Enrolled.vue'
import SimpleEnroll from '@/components/enroll/simpleEnroll.vue'
import NoAccess from '@/components/contest/NoAccess.vue'
import moment from 'moment'

export default {
  name: 'Enroll',
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    correctTime() {
      return moment(+new Date() + this.$store.state.timeDelay)
    },
    timeSets () {
      return this.$store.state.enroll.timeSets
    },
 },
  data () {
    return {
      inTime: false
    }
  },
  components: {
    fp_header: FPHeader,
    enrolled: Enrolled,
    simple_enroll: SimpleEnroll,
    no_access: NoAccess
  },
  mounted() {
    if (!this.user) {
      this.$store.commit('SET_REDIRECT', this.$router.currentRoute.fullPath)
      this.$router.push({
        name: 'account',
        params: {type: 'login'}
      })
    }
    this.timeSets.forEach((timeSet) => {
      if (this.correctTime.isBetween(timeSet.start, timeSet.end)) {
        this.inTime =  true
      }
    })
  }
}
</script>

<style scoped>
.panel{
  min-height: 70vh;
}

.spanel{
  height: 30vw;
}

.spanel, .panel{
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
</style>
